import axios from "axios";
import { serverApi } from "../../lib/config";
import { CartItem } from "../../lib/types/search";
import {
  Order,
  OrderInQuiry,
  OrderItemInput,
  OrderUpdateInput,
} from "../../lib/types/order";
import { syncAuthHeader } from "./auth";

class OrderService {
  private readonly path: string;

  constructor() {
    this.path = serverApi;
  }

  // createOrder
  public async createOrder(input: CartItem[]): Promise<Order> {
    try {
      const orderItems: OrderItemInput[] = input.map((cartItem: CartItem) => {
        return {
          itemQuantity: cartItem.quantity,
          itemPrice: cartItem.price,
          productId: cartItem._id,
        };
      });

      const url = `${this.path}/order/create`;
      syncAuthHeader();
      const result = await axios.post(url, orderItems, {
        withCredentials: true,
      });
      console.log("createOrder:", result);

      return result.data;
    } catch (err) {
      console.log("Error, createOrder:", err);
      throw err;
    }
  }

  // getMyOrders
  public async getMyOrders(input: OrderInQuiry): Promise<Order[]> {
    try {
      // axios.defaults.withCredentials = true;
      const url = `${this.path}/order/all`;
      const query = `?page=${input.page}&limit=${input.limit}&orderStatus=${input.orderStatus}`;

      syncAuthHeader();
      const result = await axios.get(url + query, {
        withCredentials: true,
      });
      console.log("getMyOrders:", result);
      
      return result.data;
    } catch (err) {
      console.log("Error, getMyOrders:", err);
      throw err;
    }
  }

  // updateOrder
  public async updateOrder(input: OrderUpdateInput): Promise<Order> {
    try {
      const url = `${this.path}/order/update`;
      syncAuthHeader();
      const result = await axios.post(url, input, {
        withCredentials: true,
      });
      console.log("updateOrder:", result);

      return result.data
    } catch (err) {
      console.log("Error, updateOrder:", err);
      throw err;
    }
  }
}

export default OrderService;
